module.exports = __webpack_public_path__ + "media/images/lb/881-92e447568d179e9e777bea8c0bab6e6a.svg";